import React, { useState, useEffect } from 'react';
import { MEDIA_OPTIONS } from '../../constants/media.constants';
import { useSelector, useDispatch } from 'react-redux';
import AddImages from './AddImages';
import { STORE_NAMES } from '../../constants/store.constants';
import { getImagesListData } from '../../service/media.service';
import MediaActions from '../../store/actions/MediaAction';

const AddMedia = () => {
  const { headerText, infoText, additionalInfoText, pdfUnsupportedText, refresh } = MEDIA_OPTIONS;

  const dispatch = useDispatch();

  const [isRefreshDisabled, setIsRefreshDisabled] = useState(false);
  const [imagesList, setImagesList] = useState([]);
  const [imageListServiceErrorStatus, setImageListServiceErrorStatus] = useState(false);

  const { appointmentRegion: region } = useSelector(state => state?.[STORE_NAMES.APPOINTMENT_DETAILS]);
  const { meetingUUID: zoomMeetingUuid } = useSelector(state => state?.[STORE_NAMES.ZOOM_CLIENT]);
  const {
    appConfig: {
      clientSettings: { mediaRefreshbuttonTimeout }
    }
  } = useSelector(state => state?.[STORE_NAMES.APP]);

  const cleanupState = () => {
    // Reset error status before starting the fetch to reset UI
    dispatch(MediaActions.setDisplayUploadServiceErrorNotification(false));
    // Hide partial error notification if it was displayed previously
    dispatch(MediaActions.setDisplayPartialErrorNotification(false));
    // Reset image list service error status to hide any previous error notifications
    setImageListServiceErrorStatus(false);
    // Clear selected images to reset UI
    dispatch(MediaActions.clearSelectedImages());
    // Reset images upload status to ensure fresh state for new fetch
    dispatch(MediaActions.resetImagesUploadStatus());
    // Reset image ID being edited to ensure no image is in edit mode
    dispatch(MediaActions.setImageIdBeingEdited(null));
  };

  // Function to fetch images from the backend API
  const fetchImages = async () => {
    cleanupState();

    // Disable image list interaction to prevent further actions while fetching images
    dispatch(MediaActions.disableImageListInteraction(true));

    try {
      const { images } = await getImagesListData(zoomMeetingUuid, region);
      setImagesList(images);
    } catch (error) {
      console.error('Error fetching images:', error);
      setImageListServiceErrorStatus(true);
    } finally {
      dispatch(MediaActions.disableImageListInteraction(false));
    }
  };

  useEffect(() => {
    fetchImages();
    return () => {
      cleanupState();
    };
  }, [zoomMeetingUuid, region]);

  const handleRefreshClick = () => {
    if (!isRefreshDisabled) {
      setIsRefreshDisabled(true);
      fetchImages();
      setTimeout(() => {
        setIsRefreshDisabled(false);
      }, mediaRefreshbuttonTimeout);
    }
  };
  const RefreshButtonClass = isRefreshDisabled ? 'refresh-disabled' : 'refresh-enabled';

  return (
    <div className="vve-add-media-text-container">
      <p className="vve-add-media-header">{headerText}</p>
      <p className="vve-info vve-medium">
        {infoText}
        <b className="vve-add-media-header"> {additionalInfoText}</b>
      </p>
      <p className="vve-media-pdf-text">{pdfUnsupportedText}</p>
      <div className={`vve-refresh-media ${RefreshButtonClass}`} onClick={handleRefreshClick}>
        <span>{refresh}</span>
        <div className="vve-refresh-icon"></div>
      </div>
      <hr className="row vve-border-line" />
      <div className="vve-images-container">
        <AddImages
          images={imagesList}
          displayImageListServiceErrorNotification={imageListServiceErrorStatus}
          setImageListServiceErrorStatus={setImageListServiceErrorStatus}
          isRefreshDisabled={isRefreshDisabled}
        />
      </div>
    </div>
  );
};

export default AddMedia;
